import { useEffect } from 'react';
import App from '../app/container';

interface DocumentsRouterProps {
  handleSetDocumentsRedirectRoute: () => void;
}

function DocumentsRouter({
  handleSetDocumentsRedirectRoute,
}: DocumentsRouterProps) {
  useEffect(() => {
    handleSetDocumentsRedirectRoute();
  }, [handleSetDocumentsRedirectRoute]);

  return <App />;
}

export default DocumentsRouter;
